export const getters = {
  getLoggedUser: state => state.loggedUser,
  getPermission: state => state.permissions,
  getToken: state => state.token,
  getSponsor: state => state.sponsor,
  getModalForgotPassword: state => state.modalEsqueciASenha
};

export default {};
